import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommitteesComponent } from './committees.component';
import { CommitteesRoutingModule } from './committees-routing.module';
import { SelectMultipleCommitteeComponent } from './select-multiple-committee/select-multiple-committee.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlsModule } from '../controls/controls.module';
import { CommitteeDetailsComponent } from './committee-details/committee-details.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SelectMultipleSectorComponent } from './select-multiple-sector/select-multiple-sector.component';
import { SelectMultipleCommitteeStatusComponent } from './select-multiple-committee-status/select-multiple-committee-status.component';
import { RecentlyViewedCommittteesComponent } from './recently-viewed-committtees/recently-viewed-committtees.component';
import { ButtonEmailCommitteeMembersComponent } from './button-email-committee-members/button-email-committee-members.component';
import { ButtonExportCommitteeDetailsComponent } from './button-export-committee-details/button-export-committee-details.component';
import { ButtonExportCommitteeMembersComponent } from './button-export-committee-members/button-export-committee-members.component';
import { ButtonScheduleCommitteeMeetingComponent } from './button-schedule-committee-meeting/button-schedule-committee-meeting.component';
import { CommitteeDetailsOverviewComponent } from './committee-details/committee-details-overview/committee-details-overview.component';
import { CommitteeDetailsCommitteeMembershipComponent } from './committee-details/committee-details-committee-membership/committee-details-committee-membership.component';
import { SubCommitteesComponent } from './sub-committees/sub-committees.component';
import { CommitteeDetailsProjectComponent } from './committee-details/committee-details-project/committee-details-project.component';
import { CommitteeDetailsPublicationComponent } from './committee-details/committee-details-publication/committee-details-publication.component';
import { SelectCommitteeComponent } from './select-committee/select-committee.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommitteeUpdatesComponent } from './committee-updates/committee-updates.component';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CommitteeDetailsInternationalParticipationComponent } from './committee-details/committee-details-international-participation/committee-details-international-participation.component';
import { CommitteeDetailsDeclarationOfInterestComponent } from './committee-details/committee-details-declaration-of-interest/committee-details-declaration-of-interest.component';



@NgModule({
  declarations: [
    CommitteesComponent,
    SelectMultipleCommitteeComponent,
    CommitteeDetailsComponent,
    SelectMultipleSectorComponent,
    SelectMultipleCommitteeStatusComponent,
    RecentlyViewedCommittteesComponent,
    ButtonEmailCommitteeMembersComponent,
    ButtonExportCommitteeDetailsComponent,
    ButtonExportCommitteeMembersComponent,
    ButtonScheduleCommitteeMeetingComponent,
    CommitteeDetailsOverviewComponent,
    CommitteeDetailsCommitteeMembershipComponent,
    SubCommitteesComponent,
    CommitteeDetailsProjectComponent,
    CommitteeDetailsPublicationComponent,
    SelectCommitteeComponent,
    CommitteeUpdatesComponent,
    CommitteeDetailsInternationalParticipationComponent,
    CommitteeDetailsDeclarationOfInterestComponent
  ],
  imports: [
    CommonModule,
    CommitteesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ControlsModule,
    FontAwesomeModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinner
  ],
  exports: [
    SelectMultipleCommitteeComponent,
    SelectCommitteeComponent,
    CommitteeUpdatesComponent
  ]
})
export class CommitteesModule { }
